'use client';

import RichText from '@/components/ui/RichText/RichText';
import CardWrapper from '@/components/layout/CardWrapper/CardWrapper';

import { OurVisionSection } from '@/features/aboutUs/hooks/types';
import OurVisionCard from './OurVisionCard';

const OurVision = ({ data }: { data: OurVisionSection }) => {
  if (!data) return null;

  const { heading, cards = [] } = data;

  return (
    <div className="content-wrapper space-y-8">
      <RichText
        styles={
          heading?.styles || {
            h2: 'text-h2 text-theme-primary mb-4 md:mb-5',
          }
        }
      >
        {heading?.content}
      </RichText>
      {cards.map((item, index: number) => (
        <CardWrapper key={index} columns="one-column">
          <OurVisionCard
            label={item.heading}
            description={item.description}
            imgUrl={item.imageUrl || ''}
            textPosition={index === 0 ? 'right' : 'left'}
          />
        </CardWrapper>
      ))}
    </div>
  );
};

export default OurVision;
